import styled from "styled-components";
import { maxSize, textLineClamp } from "../../Utils/common";
import { STYLE_TYPE } from "../../Utils/magicStrings";

export const RecommendWrapper = styled('div')`

    ${props => maxSize(110, props.styleType, 'margin-left', 0.01)};
`;

export const RecommendMainTitle = styled('div')`
    ${props => maxSize(-110, props.styleType, 'margin-left', 0.01)};
    ${props => maxSize(73, props.styleType, 'margin-top', 32)};
    ${props => maxSize(36, props.styleType, 'margin-bottom', 16)};
    ${props => maxSize(24, props.styleType, 'font-size', 14)};
    text-align: center;
`;

export const ItemWrapper = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return ``;
        } else {
            return ``;
        }
    }};
    display: inline-block;
    position: relative;
    ${props => maxSize(391, props.styleType, 'width', 269)};
    ${props => maxSize(263, props.styleType, 'height', 181)};
    ${props => maxSize(24, props.styleType, 'margin-right', 8)};
    & img {
        width: 100%;
        height: 100%;
    }
`;

export const RecommendTag = styled('div')`
    border: 1px solid white;
    border-radius: 4px;
    position: absolute;
    color: white;
    ${props => maxSize(16, props.styleType, 'top', 11)};
    ${props => maxSize(16, props.styleType, 'right', 11)};
    ${props => maxSize(14, props.styleType, 'padding-left', 10)};
    ${props => maxSize(14, props.styleType, 'padding-right', 10)};
    ${props => maxSize(12, props.styleType, 'font-size', 8)};
    ${props => maxSize(30, props.styleType, 'line-height', 22)};
`;

export const RecommendInfoWrapper = styled('div')`
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(182, 154, 103, 0.75);
    ${props => maxSize(391, props.styleType, 'width', 269)};
    ${props => maxSize(86, props.styleType, 'height', 69)};
`;

export const RecommendTitle = styled('div')`
    ${props => maxSize(24, props.styleType, 'margin-left', 16)};
    ${props => maxSize(20, props.styleType, 'margin-top', 16)};
    ${props => maxSize(343, props.styleType, 'width', 237)};
    ${props => maxSize(12, props.styleType, 'font-size', 10)};
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: white;
`;
export const RecommendContent = styled('div')`
    ${props => maxSize(24, props.styleType, 'margin-left', 16)};
    ${props => maxSize(5, props.styleType, 'margin-top', 1)};
    ${props => maxSize(343, props.styleType, 'width', 237)};
    ${props => maxSize(7.2, props.styleType, 'font-size', 8)};
    ${props => maxSize(17, props.styleType, 'line-height', 13)};
    ${textLineClamp(2)};
    color: white;
`;


